import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Parallax } from "react-scroll-parallax";

const Testimonials = () => {
  const testimonials = [
    {
      "id": 1,
      "name": "Sakshi & Sharath",
      "title": "Smart Investments, Great Returns!",
      "feedback": "I was hesitant about real estate investing until I met the experts at SpanBucks. They helped me identify the right opportunities, and now my investment is generating steady income. I truly believe in their approach—Trust, Invest, Prosper!"
    },
    {
      "id": 2,
      "name": "Saanvika",
      "title": "Trustworthy and Professional!",
      "feedback": "From the moment we connected with SpanBucks, we knew we were in good hands. Their team took the time to understand our needs and guided us through every step with honesty and transparency. We trusted them, and our investment has already started to prosper!"
    },
    {
      "id": 3,
      "name": "Nakshathra",
      "title": "A Life-Changing Decision!",
      "feedback": "Buying my first home felt overwhelming, but SpanBucks made the process seamless. They earned my trust with their honesty, helped me invest wisely, and now I am prospering in my dream home. Highly recommended!"
    },
    {
      "id": 4,
      "name": "Venkatesh",
      "title": "Long-Term Success Starts Here!",
      "feedback": "I’ve worked with multiple real estate firms, but none compare to the level of professionalism and commitment I found at SpanBucks. They don’t just sell properties—they help you build a prosperous future!"
    },
    {
      "id": 5,
      "name": "Govardhan",
      "title": "Unmatched Market Expertise!",
      "feedback": "The team at SpanBucks has an incredible understanding of market trends. They guided me to invest in an emerging area, and within a year, my property's value skyrocketed! Their market insights and innovative strategies set them apart from the rest."
    },
    {
      "id": 6,
      "name": "Vijaya Lakshmi",
      "title": "Innovative and Forward-Thinking!",
      "feedback": "What impressed me most about SpanBucks was their modern approach to real estate. They used advanced market analysis and digital tools to identify the best investment opportunities for me. Thanks to their innovative strategies, I now have a thriving real estate portfolio!"
    },
    {
      "id": 7,
      "name": "Sudheer",
      "title": "Smart Decisions, Big Results!",
      "feedback": "I’ve worked with other real estate firms, but none had the deep market understanding that SpanBucks does. They don’t just follow trends—they predict them. Because of their innovative approach, my investment is already yielding great returns!"
    },
    {
      "id": 8,
      "name": "Arjun",
      "title": "A Game-Changer in Real Estate!",
      "feedback": "From data-driven insights to creative investment solutions, SpanBucks is redefining real estate success. Their ability to analyze the market and apply innovative strategies gave me a competitive edge. If you want to make smart real estate decisions, this is the team to trust!"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className=" py-16 px-6 my-10" id="CustomersOpinion">
      <div className=" mx-auto">
      <h2 className="text-4xl text-yellow-600 z-10 font-serif text-center font-bold">What Our Customers Are Saying</h2>
        {/* Testimonial Section */}
        <div className="flex flex-col md:flex-row items-stretch">
          {/* Left Division */}
          {/* <motion.div
            className="flex-1 flex justify-center items-center text-center  p-8 relative"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <div className="text-white">
                <Parallax translateY={[-100,100]}>
              <h2 className="text-6xl z-10 font-serif font-bold">What Our Customers Are Saying</h2>
              </Parallax>
                <svg className="absolute  top-0 left-1" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 100 100">
                    <circle cx="10" cy="10" r="1" fill="#6b7280" />
                    <circle cx="20" cy="25" r="1" fill="#6b7280" />
                    <circle cx="35" cy="15" r="1" fill="#6b7280" />
                    <circle cx="50" cy="25" r="1" fill="#6b7280" />
                    <circle cx="60" cy="40" r="1" fill="#6b7280" />
                    <circle cx="75" cy="35" r="1" fill="#6b7280" />
                    <circle cx="85" cy="50" r="1" fill="#6b7280" />
                    <circle cx="50" cy="60" r="1" fill="#6b7280" />
                    <circle cx="20" cy="70" r="1" fill="#6b7280" />
                    <circle cx="30" cy="80" r="1" fill="#6b7280" />
                    <circle cx="70" cy="75" r="1" fill="#6b7280" />
                    <circle cx="85" cy="90" r="1" fill="#6b7280" />
                </svg>
            </div>
          </motion.div> */}

          {/* Right Division (Testimonial Content) */}
          <Parallax translateY={[-10,40]}
            className="flex-1 flex flex-col justify-center items-center relative border mt-36 md:mt-2 border-gray-300 p-8"
           >
          <motion.div
                      

            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            
            <motion.div
              className="text-gray-500 w-full max-w-md mx-auto"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              {/* Content changing animation */}
              
              <AnimatePresence mode="wait">
                <motion.div
                  key={testimonials[currentIndex].id}
                  className="mb-6 text-center"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  {/* <img
                    src={testimonials[currentIndex].image}
                    alt={testimonials[currentIndex].name}
                    className="w-24 h-24 rounded-full mx-auto mb-4"
                  /> */}
                  <h3 className="text-xl font-semibold text-yellow-600">{testimonials[currentIndex].name}</h3>
                  <p className="text-sm text-gray-500">{testimonials[currentIndex].title}</p>
                  <p className="italic text-lg text-gray-400 mt-4">"{testimonials[currentIndex].feedback}"</p>
                </motion.div>
              </AnimatePresence>
              
            </motion.div>

            {/* Quotation Marks */}
            <svg
              className="absolute top-0 left-0 w-28 h-28 text-gray-500 opacity-10"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              fill="currentColor"
            >
              <path d="M16 16h-4v32h12v-8h-8v-8h12V16h-12zM40 16h-4v32h12v-8h-8v-8h12V16h-12z" />
            </svg>
            <svg
              className="absolute bottom-0 right-0 w-28 h-28 text-gray-500 opacity-10"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              fill="currentColor"
            >
              <path d="M16 16h-4v32h12v-8h-8v-8h12V16h-12zM40 16h-4v32h12v-8h-8v-8h12V16h-12z" />
            </svg>
            
          </motion.div>
          <div className="flex justify-end items-center mt-6 space-x-10">
          
                <button className="swiper-button-prev bg-transparent  text-6xl border p-2 hover:pr-4 hover:pl-1 transition-all duration-300 rounded-full" onClick={handlePrev}>    
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                            <path d="M14 17l-5-5 5-5v10z" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                </button>
                <button className="swiper-button-prev bg-transparent  text-6xl border p-2 hover:pl-4 hover:pr-1 transition-all duration-300 rounded-full" onClick={handleNext}> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                            <path d="M10 17l5-5-5-5v10z" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                </button>
          
            </div>
          </Parallax>
        </div>

        {/* Navigation Controls */}
        
      </div>
    </div>
  );
};

export default Testimonials;
